/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { HOME_URL, SIGNUP_URL } from '../../config/urls';
import CustomGoogleButton from '../../components/Authentication/GoogleLogin';
import { UserContext } from '../../components/provider';
import { useNavigate } from 'react-router-dom';
import notifications from '../../utils/notifications';

const {REACT_APP_BASE_BACKEND_URL} = process.env;
const LOGIN_BACKEND_URL = `${REACT_APP_BASE_BACKEND_URL}/accounts/auth/login`

const validationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .email('Please enter a valid email address')
    .required('Email is required.'),
  password: yup
    .string()
    .required('Please specify your password')
    .min(8, 'The password should have at minimum length of 8'),
});

const Form = () => {
  const navigate = useNavigate();
  const {user, setUser} = useContext(UserContext); 
  const token = window.localStorage.getItem('jwt');
  const initialValues = {
    email: '',
    password: '',
  };
  const onSubmit = (values) => {
    fetch(LOGIN_BACKEND_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `${token && `jwt ${token}`}`
    },
      body: JSON.stringify(values)
    }).then(res => {
      if (res.status === 201) {
        return res.json()
      }
      else notifications('Wrong email or password');
    }).then(data => {
      if (data?.token){
        window.localStorage.setItem('jwt', data.token);
        const user_info = data['me'];
        const new_user = {
            name: user_info.name,
            email: user_info.email,
            profilePicture: user_info.profile_picture,
        };
        if(!new_user.profilePicture) new_user.profilePicture='./broken-image'
        setUser(new_user);
        navigate(HOME_URL)
      }
    }).catch(error => notifications());
  };    
  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit,
  });
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{
            textTransform: 'uppercase',
            fontWeight: 'medium',
          }}
          gutterBottom
          color={'text.secondary'}
        >
          Login
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
          }}
        >
          Welcome back
        </Typography>
        <Typography color="text.secondary">
          Login to manage your account.
        </Typography>
      </Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant={'subtitle2'} sx={{ marginBottom: 2 }}>
              Enter your email
            </Typography>
            <TextField
              label="Email *"
              variant="outlined"
              name={'email'}
              fullWidth
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'center' }}
              justifyContent={'space-between'}
              width={1}
              marginBottom={2}
            >
              <Box marginBottom={{ xs: 1, sm: 0 }}>
                <Typography variant={'subtitle2'}>
                  Enter your password
                </Typography>
              </Box>
              {/* <Typography variant={'subtitle2'}>
                <Link
                  component={'a'}
                  color={'primary'}
                  href={'/password-reset-simple'}
                  underline={'none'}
                >
                  Forgot your password?
                </Link>
              </Typography> */}
            </Box>
            <TextField
              label="Password *"
              variant="outlined"
              name={'password'}
              type={'password'}
              fullWidth
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
            />
          </Grid>
          <Grid item container xs={12}>
            <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
              <Typography fontSize={'1rem'} fontWeight={'600'} marginRight={'10px'}> Or </Typography>
              <CustomGoogleButton/>
            </Box>
          </Grid>
          <Grid item container xs={12}>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'center' }}
              justifyContent={'space-between'}
              width={1}
              maxWidth={600}
              margin={'0 auto'}
            >
              <Box marginBottom={{ xs: 1, sm: 0 }}>
                <Typography variant={'h6'}>
                  Don't have an account yet?{' '}
                  <Link
                    component={'a'}
                    color={'primary'}
                    href={SIGNUP_URL}
                    underline={'none'}
                  >
                    Sign up here.
                  </Link>
                </Typography>
              </Box>
              <Button size={'large'} variant={'contained'} type={'submit'}>
                Login
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Form;
